module.exports = __webpack_public_path__ + "img/brand5.6e2cdcc2.jpg";